import { Component } from '@angular/core';

@Component({
  selector: 'app-clientes-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})

export class SpinnerComponent { }



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.ts